import dayjs from 'dayjs';

export const getDeposit = (
  monthlyInstalment,
  rate,
  cashPrice,
  balloonAmt,
  periodMap,
) => {
  let balloonPVFactor = 0.0;
  let initiationFee = 0.0;

  let nacd = rate;

  //   let sdf = PeriodCalculation

  let firstInstalmentDate = periodMap.firstInstallmentDate;
  let numberOfInstalments = periodMap.noOfInstallments;
  let commencementDate = new dayjs();
  let lastInstalmentDate;
  let numberOfDays;

  if (balloonAmt > 0) {
    --numberOfInstalments;
    lastInstalmentDate = periodMap.expiryDate;

    // numberOfDays = CalendarUtils.getDaysBetween(
    //   commencementDate,
    //   lastInstalmentDate,
    // );
    numberOfDays = lastInstalmentDate.diff(commencementDate, 'day');

    balloonPVFactor = getBalloonPVFactor(numberOfDays, nacd, balloonAmt);
  }

  let totalPVFactors = getTotalPVFactors(
    nacd,
    firstInstalmentDate,
    numberOfInstalments,
  );

  let reversePrincipalDebt = totalPVFactors * monthlyInstalment;

  let reverseLoanAmount = reversePrincipalDebt;

  //? Some stuff has been left out here that may be necessary

  let reverseDeposit = cashPrice - reverseLoanAmount + initiationFee;
  reverseDeposit = reverseDeposit - balloonPVFactor;
  //   reverseDeposit = reverseDeposit.setScale(2, RoundingMode.HALF_UP);

  return reverseDeposit;
};

export const getInstalment = (principleDebt, prime, ballonAmt, periodMap) => {
  let numInstalments = periodMap.noOfInstallments;
  let out = getNACD(prime);
  let firstInstalmentDate = periodMap.firstInstallmentDate;

  let principleDebtSubPvFactor = principleDebt;
  let commencementDate = new dayjs();
  let lastInstalmentDate;
  let vPVFactor;
  let numberOfDays;

  if (ballonAmt > 0) {
    --numInstalments;
    lastInstalmentDate = periodMap.expiryDate;

    numberOfDays = lastInstalmentDate.diff(commencementDate, 'day');

    vPVFactor = getBalloonPVFactor(numberOfDays, out, ballonAmt);

    principleDebtSubPvFactor = principleDebt - vPVFactor;
  }

  let totalPVFactors = getTotalPVFactors(
    out,
    firstInstalmentDate,
    numInstalments,
  );

  return principleDebtSubPvFactor / totalPVFactors;
};

export const getTotalPVFactors = (nacd, startDate, instalments) => {
  let total = 0;
  let now = new dayjs();
  let ite = startDate;
  let numberOfInstalments = instalments;

  while (numberOfInstalments > 0) {
    let numberOfDays = ite.diff(now, 'day');

    let thisLine = getPVFactor(numberOfDays, nacd);

    total = total + thisLine;
    ite = ite.add(1, 'month');
    numberOfInstalments--;
  }
  return total;
};

export const getNACD = (interestRate) => {
  let partOne = interestRate / 1200 + 1;
  let innerPart = Math.pow(partOne, 12 / 365);
  let innerPartLessOne = innerPart - 1;
  return innerPartLessOne * 36500;
};

export const getPVFactor = (numberOfDays, nacd) => {
  let partOne = nacd / 36500;
  let partTwo = partOne + 1;
  let partThree = Math.pow(partTwo, numberOfDays);
  return 1 / partThree;
};

export const getBalloonPVFactor = (numberOfDays, nacd, ballonAmt) => {
  let partOne = nacd / 36500;
  let partTwo = partOne + 1;
  let partThree = Math.pow(partTwo, numberOfDays);
  return ballonAmt / partThree;
};

export const getInstalmentWithDeposit = (
  // monthlyInstalment,
  deposit,
  rate,
  cashPrice,
  balloonAmt,
  periodMap,
) => {
  let balloonPVFactor = 0.0;
  let initiationFee = 0.0;

  let nacd = rate;

  //   let sdf = PeriodCalculation

  let firstInstalmentDate = periodMap.firstInstallmentDate;
  let numberOfInstalments = periodMap.noOfInstallments;
  let commencementDate = new dayjs();
  let lastInstalmentDate;
  let numberOfDays;

  if (balloonAmt > 0) {
    --numberOfInstalments;
    lastInstalmentDate = periodMap.expiryDate;

    // numberOfDays = CalendarUtils.getDaysBetween(
    //   commencementDate,
    //   lastInstalmentDate,
    // );
    numberOfDays = lastInstalmentDate.diff(commencementDate, 'day');

    balloonPVFactor = getBalloonPVFactor(numberOfDays, nacd, balloonAmt);
  }

  let totalPVFactors = getTotalPVFactors(
    nacd,
    firstInstalmentDate,
    numberOfInstalments,
  );

  // let reversePrincipalDebt = totalPVFactors * monthlyInstalment;

  // let reverseLoanAmount = reversePrincipalDebt;

  // //? Some stuff has been left out here that may be necessary

  // let reverseDeposit = cashPrice - reverseLoanAmount + initiationFee;
  // reverseDeposit = reverseDeposit - balloonPVFactor;
  // //   reverseDeposit = reverseDeposit.setScale(2, RoundingMode.HALF_UP);

  // return reverseDeposit;

  let monthlyInstalment =
    (cashPrice + initiationFee - balloonPVFactor - deposit) / totalPVFactors;

  return monthlyInstalment;
};
